import React from 'react';
import { MdOutlineCancel } from "react-icons/md";

const ResetButton = ({ lable = "Clear", onClick }) => {
    return (
        <button
            type="reset"
            className="group relative inline-flex h-10 items-center justify-center border border-main-delete overflow-hidden rounded-lg text-main-delete xl:px-6 lg:px-6 px-12 transition hover:bg-main-delete/5 hover:scale-105"
            onClick={onClick}

        >
            {/* Icon */}

            <span className='flex items-center'> <MdOutlineCancel className="mr-2" size={18} />{lable}</span>

            {/* Animation effect */}
            <div className="absolute inset-0 flex h-full w-full justify-center transform skew-x-[-12deg] translate-x-[-100%] group-hover:duration-1000 group-hover:transform group-hover:translate-x-[100%]">
                <div className="relative h-full w-8 bg-main-delete/10"></div>
            </div>
        </button>
    );
};

export default ResetButton;
